import { render, staticRenderFns } from "./DigitalCertificateQr.vue?vue&type=template&id=e0a64482&scoped=true"
import script from "./DigitalCertificateQr.vue?vue&type=script&lang=js"
export * from "./DigitalCertificateQr.vue?vue&type=script&lang=js"
import style0 from "./DigitalCertificateQr.vue?vue&type=style&index=0&id=e0a64482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a64482",
  null
  
)

export default component.exports